import { Paper, styled, useTheme } from "@mui/material";
import { useGetProviderSearchListing } from "apollo/hooks/queries";
import { PROVIDER_SEARCH_PAGES, QUERY_PROGRESS_SUCCEED } from "core/consts";
import { useDateLocale } from "core/hooks/useDateLocale";
import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { ProviderSearchListing } from "core/types";
import GeneralTable, {
  TableIntro,
} from "ds_legacy/components/Tables/GeneralTable";
import {
  columnProviderSearchCapacity,
  columnProviderSearchContactDetails,
  columnProviderSearchFacility,
  columnProviderSearchLocation,
  columnProviderSearchName,
} from "ds_legacy/components/Tables/GeneralTable/CustomCells/PrintableProviderSearchListing";
import { margin } from "ds_legacy/materials/metrics";
import { usePrintWindow } from "dsl/atoms/PrintButton";
import { useProviderSearchFilterContext } from "dsl/molecules/ProviderSearchAppWrapper";
import { useProviderSearchPageData } from "dsl/molecules/ProviderSearchAppWrapper/PageMetaData";
import { useTranslations } from "translations";

const StyledTablePaper = styled(Paper)`
  @media print {
    margin: ${margin(0, 2)};
    box-shadow: none !important;
  }
`;

const PrintListing = ({
  providerListing,
}: {
  providerListing: ProviderSearchListing | undefined;
}) => {
  const translations = useTranslations();
  const getOntology = useGetOntology();
  const theme = useTheme();
  const { currentLocale: locale } = useDateLocale();

  usePrintWindow();

  if (!providerListing?.cards?.length) return null;

  return (
    <StyledTablePaper>
      <TableIntro title={translations.providersearch.listingPage.printTitle} />
      <GeneralTable
        columns={[
          columnProviderSearchName(),
          columnProviderSearchLocation({ translations }),
          columnProviderSearchContactDetails({ translations }),
          columnProviderSearchFacility({ getOntology, translations }),
          columnProviderSearchCapacity({ locale, theme, translations }),
        ]}
        data={providerListing.cards}
        emptyComponent={null}
        id="provider-listing"
      />
    </StyledTablePaper>
  );
};

export function PrintableProviderSearchListing() {
  const { filters } = useProviderSearchFilterContext();
  useProviderSearchPageData(PROVIDER_SEARCH_PAGES.PRINT_LISTING);

  const [queryProgress, providerListing] = useGetProviderSearchListing({
    filters,
  });

  if (queryProgress !== QUERY_PROGRESS_SUCCEED) return null;

  return <PrintListing providerListing={providerListing} />;
}
